import React from "react";

import DefaultLayout from "../layouts/defaultLayout";
import Dashboard from "../feature/dashboard/dashboard";
import DistrictsPage from "../feature/districts/districts";
import Schools from "../feature/schools/schools";
import Students from "../feature/students/students";
import Incidents from "../feature/incidents/incidents";
import CommandCenter from "../feature/commandCenter/commandCenter";
import Roles from "../feature/roles/roles";
import People from "../feature/people/people";
import OnCallSchedules from "../feature/oncall/onCallSchedules";
import OnCallSchedule from "../feature/oncall/onCallSchedule";
import Settings from "../feature/help/help";
import SupportReview from "../feature/support/supportReview";
import AccessLog from "../feature/accessLog/accessLog";

import DistrictPage from "../feature/districts/district";
import School from "../feature/schools/school";
import Student from "../feature/students/student";
import Incident from "../feature/incidents/incident";
import Account from "../feature/account/account";
import User from "../feature/users/user";

import Error404 from "../feature/core/error404";

const privateRoutes = (setThemeName) => {
  return [
    {
      path: "/",
      element: <DefaultLayout setThemeName={setThemeName} />,
      children: [
        { index: true, element: <Dashboard /> },
        { path: "dashboard", element: <Dashboard /> },
        { path: "districts", element: <DistrictsPage /> },
        { path: "district/:id", element: <DistrictPage /> },
        { path: "schools", element: <Schools /> },
        { path: "school/:id", element: <School /> },
        { path: "students", element: <Students /> },
        { path: "student/:id", element: <Student /> },
        { path: "people", element: <People /> },
        { path: "people/:id", element: <User /> },
        { path: "roles", element: <Roles /> },
        { path: "oncall", element: <OnCallSchedules /> },
        { path: "on-call/:id", element: <OnCallSchedule /> },
        { path: "incidents", element: <Incidents /> },
        { path: "command-center", element: <CommandCenter /> },
        { path: "incident/:id", element: <Incident /> },
        { path: "user/:id", element: <User /> },
        { path: "help", element: <Settings /> },
        { path: "support-requests", element: <SupportReview /> },
        { path: "access-log", element: <AccessLog /> },
        { path: "account", element: <Account /> },
        { path: "*", element: <Error404 /> },
      ],
    },
  ];
};

export default privateRoutes;
